import { createFileRoute, Outlet } from "@tanstack/react-router";

import {
  APP_SIDEBAR_NAME,
  AppSidebar,
} from "~/components/layout/sidebars/app-sidebar";
import { SidebarProvider } from "~/components/ui/sidebar";

export const Route = createFileRoute("/_auth/_app_shell/_main-navigation")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SidebarProvider sidebarNames={[APP_SIDEBAR_NAME]}>
      <AppSidebar name={APP_SIDEBAR_NAME} variant="inset" />
      <main className="h-svh w-full overflow-hidden md:p-2">
        <div className="bg-container flex h-full w-full overflow-hidden">
          <Outlet />
        </div>
      </main>
    </SidebarProvider>
  );
}
